export default "__VITE_ASSET__f$$365Ct__"